import { ICON_TYPES } from '../../common/Elements/Icon/Icon';
import useConfirmPopup, {
  useConfirmPopupReturn,
} from '../../common/Elements/Modal/useConfirmPopup';

const useConfirmDiscardChanges = (): useConfirmPopupReturn => {
  const [ConfirmDiscardModal, confirmDiscard, cancelDiscard] = useConfirmPopup({
    icon: { icon: 'info', iconType: ICON_TYPES.outlined },
    title: 'Discard changes',
    message: 'Do you wish to proceed?',
    modalId: 'confirm-discard-legal-document',
  });

  return [ConfirmDiscardModal, confirmDiscard, cancelDiscard];
};

export default useConfirmDiscardChanges;
